import nClicks from '@web/libs/nlog/click/codes'

import LotteryReceiptReviewMissionCardContent from './LotteryReceiptReviewMissionCardContent'
import CompletedMissionCard from '../../MissionCard/CompletedMissionCard'
import { MissionCard, MissionCardProps } from '../../MissionCard/MissionCard'
import ProgressMissionCard from '../../MissionCard/ProgressMissionCard'

interface Props {
  missionCard: MissionCardProps
}

const LotteryReceiptReviewMissionCard = ({ missionCard }: Props) => {
  const stamps = missionCard.stampGroups

  const Content = <LotteryReceiptReviewMissionCardContent stampCounts={stamps.length} />

  // 미션 완료
  if (MissionCard.isCompleteMission(missionCard)) {
    return (
      <CompletedMissionCard
        missionCard={missionCard}
        Content={Content}
        foldable
        nClickArea={{ openMore: nClicks.mission.DONECARD4, closeMore: nClicks.mission.DONEXCARD4 }}
      />
    )
  }

  return (
    <ProgressMissionCard
      missionCard={missionCard}
      Guide={<>이번 달 영수증 리뷰 수만큼 추첨에 자동 응모됩니다.</>}
      Content={Content}
      nClickArea={{
        openGuide: nClicks.mission.TIPCARD4,
        closeGuide: nClicks.mission.TIPXCARD4,
      }}
    />
  )
}

export default LotteryReceiptReviewMissionCard
